export const serviceProviderConceptTabsQueryParamName = 'tab'

export const serviceProviderConceptTabs = {
  overview: 'overview',
  initiatives: 'initiatives',
  discussions: 'discussions',
} as const
